type IconZoomProps = {
    className?: string;
};

export function IconZoom(props: IconZoomProps) {
    const { className = '' } = props;
    return (
        <svg
            aria-hidden={true}
            className={`${className}`}
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M34 34L24 24" stroke={'#000000'} strokeWidth="3" />
            <circle stroke={'#000000'} cx="15" cy="15" r="13" strokeWidth="3" strokeLinecap="square" />
        </svg>
    );
}

export default IconZoom;
